<template>
	<div ref="nav">
		<nav class="navbar" :class="{ transparent: transparent }">
			<div class="container">
				<div class="row">
					<div class="col-12">
						<div class="nav-wrapper">
							<router-link tag="a" :to="`/`">
								<img src="https://cobraticket.uy/logo.svg" alt="" class="logo only-desktop" />
								<img src="https://cobraticket.uy/iso.svg" alt="" class="logo-iso only-mobile" />
							</router-link>

							<div class="menu">
								<div class="item" v-if="$store.getters.isAuthenticated">
									<b-dropdown right variant="link">
										<template #button-content>
											<div class="item user-item ">
												<div class="only-desktop">
													{{ $store.getters.loggedUser.name }}
													{{ $store.getters.loggedUser.lastname }} <br />
													<span v-if="$store.getters.loggedUser.isPromotor">RRPP</span>
												</div>
												<b-avatar class="ml-2" size="32px"></b-avatar>
											</div>
										</template>

										<b-dropdown-item href="/account/tickets"
											><strong>Mis tickets</strong></b-dropdown-item
										>
										<b-dropdown-item href="/account/memberships"
											><strong>Mis membresias</strong></b-dropdown-item
										>
										<b-dropdown-divider></b-dropdown-divider>
										<template v-if="$store.getters.loggedUser.isPromotor">
											<b-dropdown-item href="/account/events">Mis eventos</b-dropdown-item>
											<b-dropdown-divider></b-dropdown-divider>
										</template>
										<b-dropdown-item href="/account">Mi cuenta</b-dropdown-item>
										<b-dropdown-item href="/help">Ayuda</b-dropdown-item>

										<b-dropdown-divider></b-dropdown-divider>
										<b-dropdown-item href="/logout">Salir</b-dropdown-item>
									</b-dropdown>
								</div>
								<div class="item" v-else>
									<router-link tag="a" to="/login">
										Iniciar sesión
									</router-link>
								</div>
							</div>
							<div class="search">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									class="icon icon-tabler icon-tabler-search"
									width="24"
									height="24"
									viewBox="0 0 24 24"
									stroke-width="2"
									stroke="currentColor"
									fill="none"
									stroke-linecap="round"
									stroke-linejoin="round"
								>
									<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
									<circle cx="10" cy="10" r="7"></circle>
									<line x1="21" y1="21" x2="15" y2="15"></line>
								</svg>
								<input
									type="text"
									v-model="searchText"
									placeholder="Buscar por evento o artista"
									@keyup.enter="search"
								/>
							</div>
						</div>

						<div class="categories">
							<router-link
								tag="a"
								to="/events/fiestas"
								class="item"
								:class="{ selected: $route.params.category == 'fiestas' }"
								>Fiestas</router-link
							>
							<router-link
								tag="a"
								to="/events/deportes"
								class="item"
								:class="{ selected: $route.params.category == 'deportes' }"
								>Deportes</router-link
							>
							<router-link
								tag="a"
								to="/events/musica"
								class="item"
								:class="{ selected: $route.params.category == 'musica' }"
								>Música</router-link
							>
							<router-link
								tag="a"
								to="/events/teatro"
								class="item"
								:class="{ selected: $route.params.category == 'teatro' }"
								>Teatro</router-link
							>
							<router-link
								tag="a"
								to="/events/otros"
								class="item"
								:class="{ selected: $route.params.category == 'otros' }"
								>Otros</router-link
							>
						</div>
					</div>
				</div>
			</div>
		</nav>

		<div class="nav-spacer" ref="spacer" v-if="!navFixed"></div>
	</div>
</template>

<script>
export default {
	name: "Navbar",

	props: {
		transparent: {
			type: Boolean,
			default: false
		},
		navFixed: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			searchText: ""
		}
	},
	beforeMount() {
		this.searchText = this.$route.query.s
	},
	methods: {
		search() {
			this.$router.push(`/events?s=${this.searchText}`)
		}
	}
}
</script>
<style scoped lang="scss">
.categories,
.search {
	display: none !important;
}

.search {
	width: 100%;
	height: 44px;
	border-radius: 24px;
	background-color: #fff;
	align-items: center;
	min-width: 300px;
	max-width: 400px;
	border: 1px solid #e4eef3;
	position: absolute;
	top: 10px;
	left: 240px;

	svg {
		position: absolute;
		top: 8px;
		left: 12px;
		opacity: 0.3;
		width: 16px;
	}

	input {
		width: 100%;
		height: 100%;
		border: none;
		background-color: transparent;
		color: #000;
		font-size: 14px;
		padding: 0 10px 0 36px;
	}
}

.navbar {
	top: 0px;
	width: 100%;
	background-color: #fff;
	padding: 0px 18px;
	transition: all 0.2s ease-in-out;
	min-height: 64px;
	z-index: 10;
	position: absolute;

	&.transparent {
		background-color: transparent;
		box-shadow: none;
		color: #fff;
	}

	.logo {
		width: 200px;
	}
	.logo-iso {
		width: 40px;
	}

	.container {
		display: block;
	}
}
.categories {
	width: 100%;
	display: flex;
	padding-left: 220px;

	.item {
		padding: 10px 18px;
		font-size: 14px;
		color: #202020;
		font-weight: 500;
		transition: all 0.2s ease-in-out;

		&:hover {
			color: #4599d1;
			cursor: pointer;
		}
		&.selected {
			color: #4599d1;
		}
	}
}

.nav-wrapper {
	width: 100%;
	padding-top: 10px;
	min-height: 54px;
	display: flex;
	align-items: center;
}

.nav-spacer {
	height: 64px;
}

.menu {
	flex-grow: 1;
	display: flex;
	justify-content: flex-end;
	align-items: center;

	.item {
		font-size: 14px;
		line-height: 14px;
		font-weight: 500;
		margin-right: 10px;
	}
	.user-item {
		display: flex;
		align-items: center;
		text-align: right;

		span {
			font-weight: 400;
		}
	}

	& /deep/ .btn {
		text-decoration: none;
		color: inherit;
	}
	& /deep/ .dropdown-menu {
		width: 240px;
		box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2) !important;

		.dropdown-item {
			padding: 0.9rem 1.5rem;
		}
	}
}

@media (max-width: 991px) {
	.navbar.transparent {
		color: #202020 !important;
	}
}
@media (max-width: 991px) {
	// .nav-spacer {
	// 	height: 48px;
	// }
}
</style>
